export const { MIXPANEL_TOKEN, AUTH0_CLIENT_ID, AUTH0_DOMAIN } = CONFIG;

export const CAPTCHA_URL = '6Lc499kUAAAAAA0JHTE7gmywkxeL87G9E_-8HICV';
export const HOME = 'https://rapaport.com/aboutjewelrycatalog/';
export const HOME_JLA = 'https://rapaport.com/auction-register/';
export const NO_ACTIVE_AUCTION = 'https://info.rapaport.com/jewelryauctionlp?v=1';
export const CONTACT_US = 'https://rapaport.com/jewelryauctioncontact';
export const REGISTER_MEMBER_TRADE = `${CONFIG.OLD_AUCTIONS}/flashsale-trade-bid/`;
export const REGISTER_CUSTOMER_TRADE = `${CONFIG.OLD_AUCTIONS}/flashsale-consumer-bid/`;
export const FACEBOOK_COMPANY_LINK = `https://www.facebook.com/rapaport`;
export const LINKEDIN_COMPANY_LINK = `https://www.linkedin.com/company/rapaport/`;
export const TWITTER_COMPANY_LINK = `https://twitter.com/Rapaport`;
export const PERMISSIONS = 'http://rapaport.com/permissions';

const HELP_PAGES = {
  AUCTION_TERMS_AND_CONDITIONS: 'https://rapaport.com/jewelryauctionterms/',
  COLLECTION_TERMS_AND_CONDITIONS: 'https://rapaport.com/jewelrycollectionterms/',
  AUCTION_FAQ: 'https://rapaport.com/jewelryauctionfaq',
  COLLECTION_FAQ: 'https://rapaport.com/jewelrycollectionfaq/',
  AUCTION_ABOUT: 'https://rapaport.com/jewelryauctionabout/',
  COLLECTION_ABOUT: 'https://rapaport.com/jewelrycollectionabout/',
  AUCTION_HOW_IT_WORKS: 'https://rapaport.com/how-it-works/',
  COLLECTION_HOW_IT_WORKS: 'https://rapaport.com/how-it-works-collection/'
};

export const audience = 'https://jta.rapaport.com';

export const getHelpPage = name => HELP_PAGES[`${CONFIG.AUCTION_TYPE.toUpperCase()}_${name}`];
